// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 10) return "static/chunks/580dfa14-c2d8b909d3f72c69.js";
	if (chunkId === 536) return "static/chunks/536-62e7582ec7c76a44.js";
	if (chunkId === 894) return "static/chunks/894-4a3d2fa10cfc68d7.js";
	if (chunkId === 523) return "static/chunks/523-c2f3036a67fc91e8.js";
	if (chunkId === 243) return "static/chunks/243-187fa6d9b0e431cd.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"37":"df647a4f01c85ec6","203":"6f9bb873fbccf070","369":"768f7bfb42914b48","374":"e5761b6b7b78067f","562":"423740b63a3a6e57"}[chunkId] + ".js";
};